// src/services/api.js
import axios from 'axios';
import { supabase } from '../supabaseClient';

// Cria uma instância do axios com a URL base do nosso backend
const api = axios.create({
  baseURL: 'http://localhost:3001/api', // A porta do seu backend
});

// Interceptor: Adiciona o token de autenticação em TODAS as requisições
api.interceptors.request.use(async (config) => {
    const { data: { session } } = await supabase.auth.getSession();

    if (session?.access_token) {
        config.headers.Authorization = `Bearer ${session.access_token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;